import { init as sentryInit } from '@sentry/angular';

import { ApplicationDsns } from './dsns';

/**
 * Initialize Sentry with correct environment and DSN
 */
export function init(): void {
    const env = getEnvironment();
    // @ts-ignore: Needs to be ignored. SENTRY_APPLICATION_NAME is set by webbundle build
    const applicationName = `${SENTRY_APPLICATION_NAME}`;
    const applicationDsn = ApplicationDsns[applicationName];

    /**
     * Not a known environment. Do not turn on logging
     */
    if (!env) {
        return;
    }

    /**
     * Initialize Sentry
     */
    sentryInit({
        dsn: `https://dd2618424698e10ad0d9b11d5bc14e6a@o4509050472366080.ingest.de.sentry.io/${applicationDsn}`,
        environment: env,
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true
        // integrations: [
        //     replayIntegration({
        //         maskAllInputs: true,
        //         maskAllText: true
        //     })
        // ],
        // // Session Replay
        // replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        // replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    });
}

/**
 * Determine environment based on url.
 */
export function getEnvironment(): string {
    const host = window.location.hostname;
    const envs = {
        t1: ['www-t1'],
        t2: ['www-t2'],
        acc: ['www-r1'],
        production: ['www.asnbank.nl', 'www.blgwonen.nl', 'www.regiobank.nl', 'www.snsbank.nl']
    };

    const matchingEnv = Object.keys(envs).filter((env) => {
        const urls = envs[env];
        const matchingUrl = urls.find((url) => host.includes(url));
        return matchingUrl !== undefined;
    });

    return matchingEnv[0];
}
